var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 179,
    viewBox: "0 0 210 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 201.242,
    height: 139.941,
    rx: 14,
    fill: "#181818",
    stroke: "#ECEDEA",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162.244,
    cy: 37.1895,
    r: 13.7557,
    fill: "#F58220",
    stroke: "#ECEDEA",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.429 76.1149L157.405 143.736L71.4536 143.736L114.429 76.1149Z",
    fill: "#313131",
    stroke: "#ECEDEA",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5708 61.7562L113.449 143.736L15.6927 143.736L64.5708 61.7562Z",
    fill: "#313131",
    stroke: "#ECEDEA",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e7b57fc1d555a1b7378951762396f054.svg";
export { ForwardRef as ReactComponent };